
import LayerGroup from "ol/layer/Group";
import GeoJSON from "ol/format/GeoJSON";
import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
import mainWindow, { setLayersvalue } from "../../MainWindow";
import { getLayerName } from "../../../TimeLine/MainTimeLineVisible";
import ImageLayer from "ol/layer/Image";
import ImageWMS from 'ol/source/ImageWMS';
import { map } from "../../MainLayer";


export let pressureLayerGroup = new LayerGroup({});

const format = new GeoJSON();

let receivedLayer: string = "";

type LayerMapType = Map<string, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

export let pressureMapECMWF: Map<string, LayerMapType> = new Map();
export let pressureMapICON: Map<string, LayerMapType> = new Map();

export function allPressuredMap(weatherLayerName:string,layerMap:LayerMapType){
    pressureMapECMWF.set(weatherLayerName,layerMap);
}

export function allPressuredMapICON(
    weatherLayerName: string,
    layerMap: LayerMapType
  ) {
    pressureMapICON.set(weatherLayerName, layerMap);
  }
  

export default function addPressureLayerGroup (
    receivedWeatherLayer:  ImageLayer<ImageWMS>,
    isRemove: boolean,
    layerName: string
  ): LayerGroup {
    if (!isRemove) {
      if (receivedLayer === layerName) {
        pressureLayerGroup.getLayers().clear();
      } else {
        pressureLayerGroup.getLayers().clear();
      }
      pressureLayerGroup.getLayers().push(receivedWeatherLayer);
      setLayersvalue(layerName);
      getLayerName(layerName, true);
      receivedLayer = layerName;
    } else {
        pressureLayerGroup.getLayers().forEach(function (layer) {
        if (layer.get("name") != undefined && layer.get("name") === layerName) {
            pressureLayerGroup.getLayers().remove(layer);
          pressureLayerGroup.getLayers().clear();
        }
      });
      getLayerName(layerName, false);
    }
    return pressureLayerGroup;
  }

export let ecmf: Map<number, number> = new Map([
  [0, 0],
  [1, 3],
  [2, 6],
  [3, 9],
  [4, 12],
  [5, 15],
  [6, 18],
  [7, 21],
  [8, 24],
  [9, 27],
  [10, 30],
  [11, 33],
  [12, 36],
  [13, 39],
  [14, 42],
  [15, 45],
  [16, 48],
  [17, 51],
  [18, 54],
  [19, 57],
  [20, 60],
  [21, 63],
  [22, 66],
  [23, 69],
  [24, 72],
  [25, 75],
  [26, 78],
  [27, 81],
  [28, 84],
  [29, 87],
  [30, 90],
  [31, 93],
  [32, 96],
  [33, 99],
  [34, 102],
  [35, 105],
  [36, 108],
  [37, 111],
  [38, 114],
  [39, 117],
  [40, 120],
  [41, 123],
  [42, 126],
  [43, 129],
  [44, 132],
  [45, 135],
  [46, 138],
  [47, 141],
  [48, 144],
  [49, 150],
  [50, 156],
  [51, 162],
  [52, 168],
  [53, 174],
  [54, 180],
  [55, 186],
  [56, 192],
  [57, 198],
  [58, 204],
  [59, 210],
  [60, 216],
  [61, 222],
  [62, 228],
  [63, 234],
  [64, 240],
]);

